export type MovieCategory = '剧情' | '悬疑' | '恐怖';

export interface Movie {
  id: string;
  title: string;
  year: number;
  duration: number;
  category: MovieCategory;
  tags: string[];
  director: string;
  cast: string[];
  rating: number;
  synopsis: string;
  midnightReason: string;
  poster: string;
  backdrop?: string;
  views: number;
  favorites: number;
  featured?: boolean;
}

export const CATEGORIES: {
  key: MovieCategory;
  label: string;
  en: string;
  icon: string;
  description: string;
}[] = [
  {
    key: '剧情',
    label: '剧情',
    en: 'Drama',
    icon: 'ri-moon-clear-line',
    description: '深夜里的情感与抉择，安静而克制的午夜剧情片。',
  },
  {
    key: '悬疑',
    label: '悬疑',
    en: 'Suspense',
    icon: 'ri-search-eye-line',
    description: '层层反转的线索与谜题，专为午夜烧脑时刻准备。',
  },
  {
    key: '恐怖',
    label: '恐怖',
    en: 'Horror',
    icon: 'ri-ghost-line',
    description: '午夜惊魂，慎入。适合追求肾上腺素飙升的观众。',
  },
];